import gql from 'graphql-tag';
import { creatorFragment, linksFragment, showFragment, supportedLinksFragment } from './fragments';

export const IS_SHOW_AVAILABLE = gql`
  query IsShowAvailable($input: String!) {
    isShowAvailable(itunesId: $input)
  }
`;

export const IS_VANITY_URL_AVAILABLE = gql`
  query IsVanityUrlAvailable($input: String!) {
    isVanityUrlAvailable(vanityUrl: $input)
  }
`;

export const FIND_SHOWS = gql`
  query FindShows {
    shows {
      ...showBase
      links {
        ...link
      }
      creators {
        ...showCreator
      }
    }
  }
  ${showFragment}
  ${linksFragment}
  ${creatorFragment}
`;

export const FIND_SHOW = gql`
  query FindShow($input: String!) {
    show(itunesId: $input) {
      ...showBase
      links {
        ...link
      }
      creators {
        ...showCreator
      }
    }
  }
  ${showFragment}
  ${creatorFragment}
  ${linksFragment}
`;

export const UPDATE_SHOW_LINK = gql`
  mutation UpdateShowLink($input: UpdateLinkInput) {
    updateShowLink(input: $input) {
      id
      links {
        ...link
      }
    }
  }
  ${linksFragment}
`;

export const UPDATE_SHOW_CREATOR = gql`
  mutation UpdateShowCreator($input: UpdateShowCreatorInput) {
    updateShowCreator(input: $input) {
      id
      creators {
        ...showCreator
      }
    }
  }
  ${creatorFragment}
`;

export const GET_SUPPORTED_LINKS = gql`
  query GetSupportedLinks($type: LinkTypes) {
    supportedLinks(type: $type) {
      ...link
    }
  }
  ${supportedLinksFragment}
`;

export const GET_DEFAULT_LINK = gql`
  query LinkDefaultUrl($input: LinkDefaultUrlInput) {
    linkDefaultUrl(input: $input)
  }
`;
